import React, { CSSProperties, FC, useEffect, useRef, useState } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import ReactPhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

import { ReactComponent as ConfirmIcon } from 'assets/images/checked-outlined.svg'

import './styles.scss'


interface IProps {
  onChange: (value: string) => void
  withConfirmIcon?: boolean
  confirmed?: boolean
  inputKey?: number
  error?: boolean
  errorMessage?: string
  disabled?: boolean,
  style?: CSSProperties
}

export const PhoneInput: FC<IProps> = (
  {
    onChange,
    withConfirmIcon,
    confirmed,
    inputKey,
    error,
    errorMessage,
    disabled,
    style
  }) => {
  const [dropdownWidth, setDropdownWidth] = useState<number>(0)

  const reactPhoneInputRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!reactPhoneInputRef.current) return

    let prevWidth: number = reactPhoneInputRef.current.offsetWidth
    setDropdownWidth(prevWidth)
    const resizeObserver = new ResizeObserver(changes => {
      for (const change of changes) {
        if (change.contentRect.width === prevWidth) return
        setDropdownWidth(change.contentRect.width)
        prevWidth = change.contentRect.width
      }
    })

    resizeObserver.observe(reactPhoneInputRef.current)

    return () => {
      reactPhoneInputRef.current && resizeObserver.unobserve(reactPhoneInputRef.current)
    }
  }, [reactPhoneInputRef.current])

  const onChangeNumber = (value: string) => {
    onChange(value)
  }

  return (
    <div ref={reactPhoneInputRef}
         className={cn({
           'reactPhoneInput': true,
           'reactPhoneInputConfirm': withConfirmIcon,
           'reactPhoneInputError': error
         })}
         style={style}
    >
      <ReactPhoneInput
        key={inputKey}
        disabled={disabled}
        country={'us'}
        onChange={onChangeNumber}
        autoFormat={true}
        inputProps={{
          required: true
          // autoFocus: true
        }}
        dropdownStyle={{
          width: dropdownWidth ? dropdownWidth : '300px'
        }}
      />

      {withConfirmIcon
        ? <ConfirmIcon className={cn('reactPhoneInput-confirm', {
          ['reactPhoneInput-confirmed']: confirmed
        })}/>
        : null}

      {error && errorMessage
        ? <div className={'errorMessage'}>{errorMessage}</div>
        : null}
    </div>
  )
}
